import {
	EnhancedButtonPrimeReact,
	EnhancedDialog,
	LabelPosition,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";

import { BankService } from "../../services/BankService";
import CircularProgress from '@mui/material/CircularProgress';
import { Grid } from "@mui/material";
import { VerifyBankDialogueValidationSchema } from "./validator";
import { useNavigateToLogout } from "../../common/Common";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IVerifyBankDialogue {
	openVerifyBankDialogue: boolean;
	setOpenVerifyBankDialogue: (value: any) => void
	parentFormMethods: any
	isAccountCheck?: any;
}

export const VerifyBankDialogue: FC<IVerifyBankDialogue> = ({
	openVerifyBankDialogue = false,
	setOpenVerifyBankDialogue,
	parentFormMethods,
	isAccountCheck,
}) => {
	const navigateToLogout = useNavigateToLogout();
	const [loading, setLoading] = useState<any>(false)
	const [bankDetails, setBankDetails] = useState<any>(undefined)
	const [openDialogue, setOpenDialogue] = useState(false)

	useEffect(() => {
		if (openVerifyBankDialogue) {
			setOpenDialogue(openVerifyBankDialogue)
		}
	}, [openVerifyBankDialogue])




	const onCloseVerifyBankDialogueHandler = () => {
		setOpenDialogue(false)
		setOpenVerifyBankDialogue(false)
		setBankDetails(undefined)
		formMethods.reset()
	}

	const formMethods = useForm<any>({
		resolver: yupResolver(VerifyBankDialogueValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange"
	});

	// useEffect(() => {
	// 	if (isAccountCheck !== null && isAccountCheck === "Account1") {
	// 		console.log("1111", isAccountCheck)
	// 	} else if(isAccountCheck !== null && isAccountCheck === "Account2"){
	// 		console.log("2222", isAccountCheck)
	// 	}
	// }, [isAccountCheck]);


	const [bankFinancialNo, branchTransitNumber, branchTransitNoAccount1, bankFinancialNoAccount1, branchTransitNoAccount2, bankFinancialNoAccount2] = parentFormMethods.watch(["bankFinancialNo", "branchTransitNumber", "branchTransitNoAccount1", "bankFinancialNoAccount1", "branchTransitNoAccount2", "bankFinancialNoAccount2"]);

	if (branchTransitNumber) formMethods.setValue('verifyBranchTransitNo', branchTransitNumber)
	if (bankFinancialNo) formMethods.setValue('verifyBankNo', bankFinancialNo)

	if (isAccountCheck && isAccountCheck === "Account1") formMethods.setValue('verifyBranchTransitNo', branchTransitNoAccount1)
	if (isAccountCheck && isAccountCheck === "Account1") formMethods.setValue('verifyBankNo', bankFinancialNoAccount1)

	if (isAccountCheck && isAccountCheck === "Account2") formMethods.setValue('verifyBranchTransitNo', branchTransitNoAccount2)
	if (isAccountCheck && isAccountCheck === "Account2") formMethods.setValue('verifyBankNo', bankFinancialNoAccount2)

	const verifyBankDialogueButtonClickedHandler = async (values: any) => {
		// alert(1230);
		// const [verifyBranchTransitNo, verifyBankNo] = formMethods.watch([
		// 	"verifyBranchTransitNo",
		// 	"verifyBankNo"
		// ]);


		(async () => {
			try {
				setLoading(true)
				const responce = await BankService.verifyBankDetails(values.verifyBranchTransitNo, values.verifyBankNo, navigateToLogout)
				if (responce && responce.status) {
					setBankDetails(responce)
				} else {
					setBankDetails(undefined)
				}

			} catch { } finally { setLoading(false) }
		})();
	}

	return (
		<>
			<EnhancedDialog
				dialogTitle="Simplepay.ca"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseVerifyBankDialogueHandler}
				open={openDialogue}
				dialogContent={
					<Grid>
						{loading && <CircularProgress sx={{ width: "20px!important", height: "20px!important", "& .MuiCircularProgress-svg": { width: "20px", height: "20px" } }} />}
						{bankDetails && !loading && bankDetails.bankName && bankDetails.branchAddress ?
							<><span style={{ color: "#ea580c" }}><b>Bank:</b>&nbsp;{bankDetails && bankDetails.bankName}</span> <br />
								<span style={{ color: "#ea580c" }}><b>Branch:</b>&nbsp;{bankDetails && bankDetails.branchAddress}</span></>
							: bankDetails && !loading && bankDetails.bankName && !bankDetails.branchAddress ?
								<><span style={{ color: "#ea580c" }}><b>Bank:</b>&nbsp;{bankDetails && bankDetails.bankName}</span> <br />
									<span style={{ color: "#ea580c" }}>If you know your Bank/Branch No. are correct you can ignore this Message. Send us the Bank/Brack No. and we can update our database.</span>
								</>
								: bankDetails && !loading && !bankDetails.bankName && bankDetails.branchAddress ?
									<>
										<span style={{ color: "#ea580c" }}>If you know your Bank/Branch No. are correct you can ignore this Message. Send us the Bank/Brack No. and we can update our database.</span> <br />
										<span style={{ color: "#ea580c" }}><b>Branch:</b>&nbsp;{bankDetails && bankDetails.branchAddress}</span>

									</>
									: bankDetails && !loading && !bankDetails.bankName && !bankDetails.branchAddress ?
										<span style={{ color: "#ea580c" }}>Unknown Bank</span>
										: <></>
						}
						<br />
						<br />
						<FormProvider {...formMethods}>
							<form onSubmit={formMethods.handleSubmit(verifyBankDialogueButtonClickedHandler)}>
								<RHookFormMaskedTextFieldWithLabel
									label="Enter Branch/Transit No."
									id="verifyBranchTransitNo"
									testId={`verifyBranchTransitNo`}
									placeholder={"00000"}
									inputMaskPattern={"00000"}
								/>
								{/* <RHookFormTextFieldWithLabel
									label="Bank No."
									id="verifyBankNo"
									testId={`verifyBankNo`}
								/> */}
								<RHookFormMaskedTextFieldWithLabel
									label="Enter Bank No."
									id="verifyBankNo"
									testId={`bank-code`}
									labelPosition={LabelPosition.Top}
									placeholder={"0000"}
									inputMaskPattern={"0000"}
								/>
							</form>
						</FormProvider>
					</Grid>
				}
				showdividers={false}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							text
							raised
							onClickHandler={onCloseVerifyBankDialogueHandler}
							style={{ fontSize: "small" }}
						/>
						<EnhancedButtonPrimeReact
							label="Verify"
							severity="success"
							raised
							// onClickHandler={verifyBankDialogueButtonClickedHandler}
							onClickHandler={formMethods.handleSubmit(verifyBankDialogueButtonClickedHandler)}
							type="submit"
							style={{ marginLeft: "16px", fontSize: "small" }}
						/>
					</Grid>
				}
			/>
		</>
	);
};
